class MenuConfigConstant{

    constructor() {
        this.menu = [
            {
                'text': 'Home',
                'state': '/.coi.home',
                'logoutItem' : true,
                'sub': [
                    {
                        'text': 'Disclose',
                        'state': '/.coi.disclose'
                    }, {
                        'text': 'My Disclosures',
                        'state': '/.coi.mydisclosures'
                    }, {
                        'text': 'Line Manager Tasks',
                        'state': '/.coi.mytasks'
                    }
                ]
            },
            {
                'text': 'Admin',
                'state': '/.admin.home',
                'role': ['Admin'],
                'sub': [
                    {
                        'text': 'Manage Disclosures',
                        'state': '/.admin.managedisclosures'
                    }
                ]
            }
        ];
    }

    $get() {
        return this.menu;
    }
}

export default MenuConfigConstant;


// WEBPACK FOOTER //
// ./app/menu.config.provider.js